<template>
  <div class="border overflow-hidden rounded" v-if="items.length">
    <b-table :fields="fields" :items="items" borderless responsive foot-clone>
      <template #cell(index)="data">{{ data.index + 1 }}</template>
      <template #foot()="data">
        <span></span>
      </template>
      <template #foot(purchase_order)="data">
        <div class="body-font-button-sm text-neutral-950">Total</div>
      </template>
      <template #foot(quantity)="quantity">
        <div class="text-right body-font-button-sm text-neutral-950">{{ $numeral(totalQuantity).format('0,0.[00]') }}</div>
      </template>
      <template #foot(total_price)="quantity">
        <div class="text-right body-font-button-sm text-neutral-950">{{ $numeral(totalPrice).format('0,0.[00]') }}</div>
      </template>
    </b-table>
  </div>
  <div v-else>-</div>
</template>

<script>
  export default {
    props: {
      items: {
        type: [Array],
        default: () => [],
      },
      productType: {
        type: String,
        default: undefined,
      }
    },
    computed: {
      fields(){
        const vm = this;
        return [
          {key: 'index', label: 'No', sortable: false, style: {width: '1%'}},
          {
            key: 'purchase_order',
            label: `${this.lodash.startCase(this.$t('trip_items.purchase_order_id'))}`,
            tdClass: 'text-start',
            formatter: (value) => `${value.id} (${value.customer.name} ${value.ordered_at ? (' - ' + vm.$moment.utc(value.ordered_at).local().format('DD MMM YYYY')) : ''})`
          },
          {
            key: 'purchase_item.quality',
            label: `${this.lodash.startCase(this.$t('trip_items.quality'))}`,
            formatter: (value) => value ? this.$t(`qualities.${value}`) : '-'
          },
          {
            key: 'quantity',
            label: `${this.lodash.startCase(this.$t('trip_items.quantity'))} (${this.$t('kg')})`,
            tdClass: 'text-end',
            formatter: (value) => vm.$numeral(value).format('0,0.[00]')
          },
          {
            key: 'size',
            label: `${this.lodash.startCase(this.$t('trip_items.size'))}`,
            tdClass: 'text-end',
            formatter: (value) => vm.$numeral(value).format('0,0.[00]')
          },
          {
            key: 'unit_price',
            label: `${this.lodash.startCase(this.$t('trip_items.unit_price'))} (Rp)`,
            tdClass: 'text-end',
            formatter: (value) => vm.$numeral(value).format('$ 0,0.[00]')
          },
          { key: 'total_price',
            label: `${this.lodash.startCase(this.$t('trip_items.total_price'))} (Rp)`,
            tdClass: 'text-end',
            formatter: (value) => vm.$numeral(value).format('$ 0,0.[00]')
          },
          {
            key: 'label',
            label: `${this.lodash.startCase(this.$t('trip_items.label'))}`,
            formatter: (value) => value || '-',
            _denyShow: this.productType === 'hybrid'
          },
          {
            key: 'customer.name',
            label: `${this.lodash.startCase(this.$t('trip_items.farmer'))}`,
            formatter: (value) => value || '-',
          },
        ].filter(field => !field._denyShow);
      },
      totalPrice(){
        return this.items.reduce((prev, curr) => prev + curr.total_price, 0);
      },
      totalQuantity(){
        return this.items.reduce((prev, curr) => prev + curr.quantity, 0);
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/design/colors";
  ::v-deep {
    .overflow-hidden {
      overflow: hidden !important;
    }
    table {
      th {
        background: #F9FAFB !important;
      }

      thead {
        th * {
          color: $neutral-600;
        }
      }

      tbody {
        tr{
          border-bottom: 1px solid $slate-200 !important;
        }
      }

    }
    .table-responsive {
      margin-bottom: 0;
    }
    .text-right {
      text-align: right;
    }
  }
</style>